module.exports = __webpack_public_path__ + "static/img/home_page bottom_desktop.21c34efb.jpg";